import React from 'react';
import HeroImage from './HeroImage.js';
import PropTypes from 'prop-types';

const searchResults = ({ ...props }) => {
  if (!props.isDisabled) {
    return null;
  }

  return props.partnerResults
    .sort((a, b) =>
      a.fields['partner_university copy'] > b.fields['partner_university copy']
        ? 1
        : -1
    )
    .map((record) => {
      let subjectList = '';
      if (record.fields['subject']) {
        subjectList = record.fields['subject'].map((subject, index) => {
          return <li key={index}>{subject}</li>;
        });
      }

      return (
        <div className="ga-uni" key={record.id}>
          <div className="ga-uni-title">
            {record.fields.website ? (
              <h2>
                <a
                  href={record.fields.website}
                  title={`${record.fields['partner_university copy']} website`}
                >
                  {record.fields['partner_university copy']}
                </a>
              </h2>
            ) : (
              <h2>{record.fields['partner_university copy']}</h2>
            )}
            <p>{record.fields.location}</p>
          </div>

          {record.fields['image'] ? (
            <HeroImage
              img={record.fields['image'][0]}
              alt={record.fields['partner_university copy']}
            />
          ) : (
            <img
              src="https://www.bris.ac.uk/university/media/global-opps/ga-image-not-found.png"
              alt="Not found"
            />
          )}
          {record.fields.image_caption ? (
            <p className="ga-img-caption">{record.fields.image_caption}</p>
          ) : null}

          <p>{record.fields.description}</p>

          <table className="table-basic">
            <tbody>
              <tr>
                <th>Language</th>
                <td>{record.fields.language}</td>
              </tr>
              <tr>
                <th>Semester Dates </th>
                <td>{record.fields.semester_dates}</td>
              </tr>
              <tr>
                <th>Competitiveness</th>
                <td>{record.fields.Competitiveness}</td>
              </tr>
              {record.fields.student_population ? (
                <tr>
                  <th>Student population</th>
                  <td>{record.fields.student_population.toLocaleString()}</td>
                </tr>
              ) : null}
            </tbody>
          </table>
          <h4>Owning departments and teaching blocks</h4>
          <ul>{subjectList}</ul>
          {record.fields.living_costs ? (
            <a
              className="btn icon-arrow-right ga-btn-margin"
              href={record.fields.living_costs}
              target="_blank"
            >
              Living Costs
            </a>
          ) : null}
          {record.fields.accommodation ? (
            <a
              className="btn icon-arrow-right ga-btn-margin"
              href={record.fields.accommodation}
              target="_blank"
            >
              Accommodation
            </a>
          ) : null}
        </div>
      );
    });
};
export default searchResults;

searchResults.propTypes = {
  partnerData: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/searchResults.js